export function getInvoiceDeliveryDateEndpoint(): string {
    return '/invoice-delivery';
}
